import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
import { Countdown } from '../Countdown';
import { PriceCard } from '../PriceCard';
import { pricing } from '../../data/landing';
export function Offer() {
  return <section id="oferta" className="scroll-mt-4 border-y border-line bg-surface px-5 py-16 md:py-24" data-id="element-213" data-mp="309m036thtxca">
      <div className="mx-auto max-w-3xl" data-id="element-214" data-mp="353zpmslh5a91">
        <div className="rounded-3xl border border-line bg-ink p-7 text-center md:p-10" data-id="element-215" data-mp="3a4dxa9j5yi6j">
          <p className="flex items-center justify-center gap-2 text-sm font-black uppercase tracking-[0.15em] text-heading md:text-base" data-id="element-216" data-mp="3f3qiyqyatj7j">
            <ClockIcon className="h-5 w-5 text-danger" aria-hidden="true" data-id="element-217" data-mp="3jw1u6pyhorfe" />
            Precio de lanzamiento — cierra en:
          </p>
          <div className="mt-6" data-id="element-218" data-mp="3svy9i0yzodxs">
            <Countdown data-id="element-219" data-mp="3swzpmjuv3qmd" />
          </div>
          <p className="mt-6 inline-flex items-center justify-center gap-2 rounded-full border border-line bg-surface px-4 py-2 text-base font-semibold text-heading" data-id="element-220" data-mp="3stu053ibmmq4">
            <AlertTriangleIcon className="h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-221" data-mp="1km9lf1zd43t1" />
            Después sube {pricing.increase}. No vuelve más.
          </p>

          <div className="mt-8 text-left" data-id="element-222" data-mp="1bka1o1wyqlme">
            <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-223" data-mp="1blbo12jfiujf">
              <span className="flex items-center gap-2 text-heading" data-id="element-224" data-mp="16n0e6rt4wk17">
                <span className="relative flex h-2.5 w-2.5" data-id="element-225" data-mp="23chltcbogg5j">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-success opacity-75 motion-reduce:animate-none" data-id="element-226" data-mp="23dsmh39tt7sf" />
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-success" data-id="element-227" data-mp="1uimcds3iw3k3" />
                </span>
                Quedan pocos cupos al precio de lanzamiento
              </span>
              <span className="text-success" data-id="element-228" data-mp="2n0766yhabe4q">{pricing.claimedPercent}%</span>
            </div>
            <div className="mt-3 h-3 overflow-hidden rounded-full bg-line" role="progressbar" aria-valuenow={pricing.claimedPercent} aria-valuemin={0} aria-valuemax={100} data-id="element-229" data-mp="2i8ys3p50f4l8">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: `${pricing.claimedPercent}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              ease: [0.23, 1, 0.32, 1]
            }} className="h-full rounded-full bg-success" data-id="element-230" data-mp="364k9jq5f3o20" />
            </div>
            <p className="mt-2 text-sm text-body" data-id="element-231" data-mp="2idoduhxuc8ph">
              {pricing.claimedPercent}% de los cupos ya tomados
            </p>
          </div>
        </div>

        <h2 className="mt-16 text-center text-3xl font-black uppercase tracking-tight text-heading md:text-5xl" data-id="element-232" data-mp="29f2yswrkvbtg">
          Elegí tu MegaPack
        </h2>
        <div className="mt-10" data-id="element-233" data-mp="2dhpu57ngjeve">
          <PriceCard subtitle="6 Tomos + 6 Bonos" idealFor="Quienes quieren recuperar enfoque de 7 a 30 días" ctaLabel="Quiero el MegaPack ahora" originalPrice="$108.000" currentPrice="$38.990" data-id="element-234" data-mp="7mesgejn089g" />
        </div>
      </div>
    </section>;
}